import * as React from "react";
import { Controller, useFormContext, RegisterOptions } from "react-hook-form";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface InputHookProps {
  name: string;
  label?: string;
  placeholder?: string;
  type?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  inputMode?:
    | "none"
    | "text"
    | "tel"
    | "url"
    | "email"
    | "numeric"
    | "decimal"
    | "search";
  pattern?: string;
  rules?: RegisterOptions;
}

export const InputHook = ({
  name,
  label,
  placeholder,
  type = "text",
  disabled = false,
  required = false,
  className,
  inputMode,
  pattern,
  rules,
}: InputHookProps): React.ReactElement => {
  const { control } = useFormContext();

  return (
    <div
      className={`flex flex-col gap-0.5 bg-background rounded-md ${className || ""}`}
    >
      {label && (
        <Label htmlFor={name} className="mb-1.5">
          {label}
          {required && <span className="text-destructive">*</span>}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        rules={
          rules || {
            required: required ? `${label || name} is required` : false,
          }
        }
        render={({ field, fieldState }) => (
          <>
            <Input
              id={name}
              type={type}
              inputMode={inputMode}
              pattern={pattern}
              disabled={disabled}
              placeholder={placeholder}
              className={
                fieldState.error
                  ? "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20 focus-visible:ring-offset-0"
                  : ""
              }
              {...field}
            />
            {fieldState.error && (
              <span className="text-sm text-destructive">
                {fieldState.error.message}
              </span>
            )}
          </>
        )}
      />
    </div>
  );
};
